export default __webpack_public_path__ + "static/1778-2118afb1454301a0a765097b5de78e40.gif";